import {
  DialogContent,
  Grid,
  Autocomplete,
  Chip,
  Switch,
  Stack,
  Tooltip,
  IconButton,
  Icon,
} from "@mui/material";
import { Formik } from "formik";
import MDButton from "components/MDButton";
import MDDialog from "components/MDDialog";
import MDSnackbar from "components/MDSnackbar";
import MDInput from "components/MDInput";
import MDDataGrid from "components/MDDataGrid/MDDataGrid";
import { useMaterialUIController } from "context";
import { useRef, useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import CircularIndeterminate from "components/MDLoading";
import MDTypography from "components/MDTypography";
import {
  createPermitsOption,
  updatePermitsOption,
} from "store/slice/permitsOptions/permitsOptionSlice";
import {
  getPermitsOptions,
  deletePermitsOption,
} from "store/slice/permitsOptions/permitsOptionSlice";
import DeleteDialog from "components/UIComponents/DeleteDialog";
import { get } from "lodash";

const PermitTypes = (props) => {
  const formikRef = useRef(null);
  const dispatch = useDispatch();
  const [controller] = useMaterialUIController();
  const { sidenavColor } = controller;
  const { dialogOpen, onClose } = props;

  const selectedPlace = useSelector((state) => state.places?.selectedPlace);
  //   const ratesByPlace = useSelector((state) => state.rates?.ratesByPlace);
  const permitsOptions = useSelector(
    (state) => state.permitsOptions?.permitsOptions
  );
  const loading = useSelector((state) => state.permitsOptions?.loading);

  const [isLoading, setIsLoading] = useState(false);
  //   const [customRates, setCustomRates] = useState([]);
  const [deleteDialogOpen, setDeleteDialogOpen] = useState(false);
  const [deleteTarget, setDeleteTarget] = useState(null);
  const [notification, setNotification] = useState({
    color: "",
    icon: "",
    title: "",
    content: "",
    show: false,
    close: () => setNotification({ ...notification, show: false }),
  });

  //   useEffect(() => {
  //     if (ratesByPlace) {
  //       const customRates = ratesByPlace.filter(rate => rate.rateType === 'custom')

  //       setCustomRates(customRates);
  //     }
  //   }, [ratesByPlace]);

  useEffect(() => {
    // console.log("permitsOptions changed:", permitsOptions);
    // if (permitsOptions && permitsOptions.length > 0) {
    //   formikRef?.current?.setFieldValue(
    //     "customRates",
    //     get(permitsOptions, "[0].customRates", [])
    //   );
    //   formikRef?.current?.setFieldValue(
    //     "customConfirmationMessage",
    //     get(permitsOptions, "[0].customConfirmationMessage", "")
    //   );
    //   formikRef?.current?.setFieldValue(
    //     "displayUnitNumber",
    //     get(permitsOptions, "[0].displayUnitNumber", false)
    //   );
    //   formikRef?.current?.setFieldValue(
    //     "selectedPermitType",
    //     get(permitsOptions, "[0]", "")
    //   );
    //   formikRef?.current?.setFieldValue(
    //     "id",
    //     get(permitsOptions, "[0]._id", "")
    //   );
    // }
  }, [permitsOptions]);

  const handleSavePermitsOption = async (params) => {
    try {
      setIsLoading(true);
      const res = await dispatch(updatePermitsOption(params)).unwrap();
      const success = res?.success;
      setNotification({
        ...notification,
        color: success ? "success" : "error",
        title: success ? "Success" : "Error",
        content: res?.message || "An unexpected error occurred.",
        icon: success ? "check" : "warning",
        show: true,
      });
      // if (success) {
      //   onClose();
      // }
    } catch (err) {
      console.error("Error creating permit:", err);
      setNotification({
        ...notification,
        color: "error",
        title: "Error",
        content: err?.message || "An error occurred while creating permit.",
        icon: "warning",
        show: true,
      });
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <>
      <CircularIndeterminate
        type="full"
        size={20}
        text={"Please wait..!"}
        open={isLoading || loading}
      />
      <MDSnackbar
        color={notification.color}
        icon={notification.icon}
        title={notification.title}
        content={notification.content}
        open={notification.show}
        close={notification.close}
        bgWhite
      />
      <MDDialog
        dialogTitle="Permit Types"
        open={dialogOpen}
        dialogClose={onClose}
        closeIcon={true}
        maxWidth="sm"
      >
        <DialogContent>
          <Formik
            innerRef={formikRef}
            initialValues={{
              placeId: selectedPlace?._id,
              id: get(permitsOptions, "[0]._id", ""),
              newPermitType: "",
              customRates: get(permitsOptions, "[0].customRates", []),
              customConfirmationMessage: get(
                permitsOptions,
                "[0].customConfirmationMessage",
                ""
              ),
              selectedPermitType: get(permitsOptions, "[0]", []),
              displayUnitNumber: get(
                permitsOptions,
                "[0].displayUnitNumber",
                false
              ),
            }}
            enableReinitialize
            // validationSchema={CreatePermitSchema}
            onSubmit={(value, action) => {
              const payload = {
                id: value.id,
                customRates: value.customRates,
                customConfirmationMessage: value.customConfirmationMessage,
                displayUnitNumber: value.displayUnitNumber,
              };

              handleSavePermitsOption(payload);
            }}
          >
            {(props) => (
              <form onSubmit={props.handleSubmit}>
                <Grid
                  container
                  spacing={1}
                  // className="mt-1"
                  alignItems="center"
                >
                  <Grid item xs={8} sm={9}>
                    <MDInput
                      name="newPermitType"
                      value={props.values.newPermitType}
                      onChange={props.handleChange}
                      onBlur={props.handleBlur}
                      label="New Permit Type"
                      error={
                        !!props.errors.newPermitType &&
                        props.touched.newPermitType
                      }
                      success={
                        !(
                          props.errors.newPermitType &&
                          props.touched.newPermitType
                        )
                      }
                      helperText={
                        props.errors.newPermitType &&
                        props.touched.newPermitType
                          ? props.errors.newPermitType
                          : ""
                      }
                      fullWidth
                    />
                  </Grid>
                  <Grid
                    item
                    xs={4}
                    sm={3}
                    sx={{
                      display: "flex",
                      justifyContent: { xs: "flex-start", sm: "flex-end" },
                    }}
                  >
                    <MDButton
                      color={sidenavColor}
                      variant="contained"
                      fullWidth
                      disabled={props.values.newPermitType.trim() === ""}
                      onClick={() => {
                        if (props.values.newPermitType.trim() !== "") {
                          dispatch(
                            createPermitsOption({
                              placeId: selectedPlace._id,
                              type: props.values.newPermitType.trim(),
                            })
                          ).then((res) => {
                            const success = res?.payload?.success;

                            if (!success) {
                              setNotification({
                                ...notification,
                                color: "error",
                                title: "error",
                                content: res?.payload?.message,
                                icon: "warning",
                                show: true,
                              });
                            }
                          });
                        }
                      }}
                      // sx={{ mt: { xs: 1, sm: 0 } }}
                    >
                      Save
                    </MDButton>
                  </Grid>
                </Grid>
                <Grid container spacing={2} className="mt-2">
                  <Grid item xs={12}>
                    <MDTypography variant="h6" sx={{ mb: 1 }}>
                      Existing Permit Types
                    </MDTypography>
                    <MDDataGrid
                      rows={permitsOptions || []}
                      columns={(() => {
                        const cols = [
                          { field: "type", headerName: "Type", width: 300 },
                          {
                            field: "actions",
                            headerName: "Actions",
                            width: 120,
                            renderCell: ({ row }) => (
                              <Stack direction="row" alignItems="center">
                                <Tooltip title="Delete" placement="top">
                                  <IconButton
                                    color="error"
                                    onClick={() => {
                                      setDeleteTarget(row);
                                      setDeleteDialogOpen(true);
                                    }}
                                  >
                                    <Icon fontSize="small">delete</Icon>
                                  </IconButton>
                                </Tooltip>
                              </Stack>
                            ),
                          },
                        ];
                        return cols;
                      })()}
                      getRowId={(row) => row._id}
                      autoHeight
                      disableSelectionOnClick
                    />
                  </Grid>
                </Grid>
                <DeleteDialog
                  dialogOpen={deleteDialogOpen}
                  onClose={() => setDeleteDialogOpen(false)}
                  handelClick={async () => {
                    if (!deleteTarget) return;
                    try {
                      setIsLoading(true);
                      const res = await dispatch(
                        deletePermitsOption({ id: deleteTarget._id })
                      ).unwrap();
                      const success = res?.success;
                      setNotification({
                        ...notification,
                        color: success ? "success" : "error",
                        title: success ? "Success" : "Error",
                        content: res?.message || "",
                        icon: success ? "check" : "warning",
                        show: true,
                      });
                      if (success) {
                        dispatch(
                          getPermitsOptions({ placeId: selectedPlace?._id })
                        );
                      }
                    } catch (err) {
                      setNotification({
                        ...notification,
                        color: "error",
                        title: "Error",
                        content: err?.message || "Unable to delete",
                        icon: "warning",
                        show: true,
                      });
                    } finally {
                      setIsLoading(false);
                      setDeleteDialogOpen(false);
                      setDeleteTarget(null);
                    }
                  }}
                />
              </form>
            )}
          </Formik>
        </DialogContent>
      </MDDialog>
    </>
  );
};

export default PermitTypes;
